<template>
  <v-form
    :lazy-validation="true"
    @submit.prevent="handleSubmit"
    v-model="valid"
    ref="form"
  >
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>{{ $t("common.create") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-card-text>
        <v-autocomplete
          autocomplete="off"
          prepend-icon="mdi-view-module-outline"
          :loading="status.loading"
          :label="$t('device.fields.template')"
          v-model="template"
          :items="templates"
          item-text="templateName"
          return-object
        />
      </v-card-text>

      <v-card-text>
        <v-autocomplete
          autocomplete="off"
          prepend-icon="mdi-domain"
          :loading="status.loading"
          :label="$t('device.fields.device')"
          v-model="device"
          :items="devices"
          item-text="serialNumber"
          item-value="deviceId"
          :rules="requiredRule"
        />
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('device.fields.label')"
          name="label"
          prepend-icon="mdi-domain"
          type="text"
          v-model="payload.Label"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-autocomplete
          autocomplete="off"
          v-if="device != null && template.key == undefined"
          prepend-icon="mdi-key-variant"
          :loading="status.loading"
          :label="$t('device.fields.key')"
          v-model="payload.key"
          :items="keys"
        />
      </v-card-text>

      <v-card-text v-if="template.key == undefined">
        <v-text-field
          :label="$t('device.fields.modifier')"
          name="modifier"
          prepend-icon="mdi-view-module-outline"
          type="text"
          v-model="payload.Modifier"
        ></v-text-field>
        <span>{{ $t("device.fields.modifierDescription") }}</span>
      </v-card-text>

      <v-card-text>
        <v-switch
          v-model="payload.Ignore"
          :label="$t('device.fields.ignore')"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" type="submit" x-large>{{
          $t("common.create")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "CreateDevice",
  data() {
    return {
      template: { templateName: this.$t("device.fields.templateDefault") },
      device: null,
      valid: false,
      payload: {
        Label: "",
        Key: "",
        Modifier: "",
        Ignore: false
      },
      nameRules: [
        v => !!v || this.$t("common.validation.required"),
        v => (v && v.length <= 255) || this.$t("common.validation.max")
      ],
      requiredRule: [v => !!v || this.$t("common.validation.required")]
    };
  },

  computed: {
    ...mapState("devices", ["status", "devices", "keys"]),
    ...mapState("deviceFields", ["fields", "templates"])
  },

  methods: {
    ...mapActions("deviceFields", {
      create: "create",
      getTemplates: "getTemplates"
    }),
    ...mapActions("devices", { getDevices: "get", getKeys: "getKeys" }),

    async handleSubmit() {
      if (!this.$refs.form.validate() || this.device == null) {
        this.valid = false;
        return;
      }

      // Handle submit here
      await this.create({ deviceId: this.device, payload: this.payload });
      this.$router.go(-1);
    }
  },

  async created() {
    await this.getDevices();
    await this.getTemplates();
    this.templates.push({
      templateName: this.$t("device.fields.templateDefault")
    });

    if (this.$route.params.id != undefined) {
      this.device = parseInt(this.$route.params.id);
    }
  },

  watch: {
    async device(val) {
      if (val != null) {
        await this.getKeys(val);
      }
    },

    template(val) {
      if (val.key != undefined) {
        this.payload.Label = val.fieldName;
        this.payload.Key = val.key;
        this.payload.Modifier = val.modifier;
      }
    }
  }
};
</script>

<style scoped></style>>
